import { useState, useEffect } from 'react'

function isSafariBrowser() {
  if (typeof navigator === 'undefined') return false
  const userAgent = navigator.userAgent.toLowerCase()
  // Chrome on iOS identifies as "CriOS" rather than "Chrome"
  return userAgent.includes('safari') && !userAgent.includes('chrome') && !userAgent.includes('crios')
}

export default function useIsSafari() {
  const [isSafari, setIsSafari] = useState(false)

  useEffect(() => {
    setIsSafari(isSafariBrowser())
  }, [])

  return isSafari
}
